import { render } from "./WorkInProgress.vue?vue&type=template&id=2200be90"
import script from "./WorkInProgress.vue?vue&type=script&lang=js"
export * from "./WorkInProgress.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__